module.exports = __webpack_public_path__ + "img/image_circle.3566b344.png";